import NotificationTemplatesListItem from "./NotificationTemplatesListItem";

export default function NotificationTemplatesList({ notifications }) {
  return (
    <>
      {notifications.map((notification) => (
        <NotificationTemplatesListItem notification={notification} />
      ))}
    </>
  );
}
